import React, {createContext, useState} from 'react';

const RefundInfoContext = createContext({
    isLoading: false,
    actionLocation: '',
    chatWidgetCounter: 0,
    showRefundInfo: false,
    updateActionLocation: () => {},
    updateChatWidgetCounter: () => {},
    updateRefundInfoFlag: () => {},
});

export const RefundInfoProvider = (props) => {
    const [actionLocation, setActionLocation] = useState('');
    const [chatWidgetCounter, setChatWidgetCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showRefundInfo, setShowRefundInfo] = useState(false);

    const updateActionLocation = (location) => {
        setActionLocation(location);
    };

    const updateChatWidgetCounter = () => {
        setChatWidgetCounter((currentCounter) => currentCounter + 1);
    };

    const updateIsLoading = (value) => {
        setIsLoading(value);
    };

    const updateRefundInfoFlag = () => {
        setShowRefundInfo(true);
    };

    const context = {
        actionLocation,
        chatWidgetCounter,
        isLoading,
        showRefundInfo,
        updateActionLocation,
        updateChatWidgetCounter,
        updateIsLoading,
        updateRefundInfoFlag,
    };

    return (
        <RefundInfoContext.Provider value={context}>
            {props.children}
        </RefundInfoContext.Provider>
    );
};

export default RefundInfoContext;
